<template>
  <div class="chart-menu-components-df">
    <div class="mian">
      <div class="wrap">
        <ul class="menulist wrapper_menu">
          <li class="menu_item" v-for="(item, idx) in dflotteryTypes" :key="idx" @mouseenter="setIshowIdx(idx)"
            @mouseleave="isShow = null">
            <div class="menu_title"> {{ item.lotteryTypeName }}
              <div class="arrow"></div>
              <ul class="menuItem inner_menu" :class="[
            item.lotteryTypeCode == 'K3' ? 'column-three' : '',
            item.lotteryTypeCode == 'SSC' ? 'column-one' : '',
            item.lotteryTypeCode == 'ZHISHU' ? 'column-one' : '',
            item.lotteryTypeCode == 'DLT' ? 'column-one' : ''
          ]" :style="idx == isShow ? 'display: grid;' : 'display: none;'">
                <li v-for="(item, i) in ltList(item.lotteryTypeCode)" @click="toLottery(item)">{{ item.lotteryName }}
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="chart-lottery-component">
          <template>
            <openLottery :list="lotteryLatelyLpVo" :cdn="'https://qny-zhzy.mcjdzsw.top/'" :lotteryCode="lotteryCode" :page="'lotterychart'">
            </openLottery>
          </template>
        </div>
        <div class="select-trand">
          <div class="select-header">
            <div class="select-top">
              <div class="check-click">
                <div class="checkbox-wrapper">
                  <q-checkbox v-model="statisticalShow" size="xs" label="辅助线" color="red" />
                </div>
                <div class="checkbox-wrapper"><q-checkbox v-model="onMissHandleChange" size="xs" label="遗漏"
                    color="red" /></div>
                <div class="checkbox-wrapper"><q-checkbox v-model="lineChartShow" size="xs" label="走势" color="red" />
                </div>
              </div>
              <div class="time">
                <span v-for="(item, i) in qsList" :key="i" @click="periodsLimit = item.val"
                  :class="periodsLimit == item.val && 'active'">
                  {{ item.name }}
                </span>
              </div>
            </div>
            <div class="select-line"></div>
            <div class="select-bottom">
              <div class="choose-play">
                <span class="select-title">选择玩法 ：</span>
                <ul class="select-list" v-if="lotteryTypeCode === 'SSC'">
                  <li @click="selectPlay(item)" :class="{ 'active': currPlay === item.code }"
                    v-for="(item, index) in SscSelect" :key="index">
                    <a>{{ item.text }}</a>
                  </li>
                </ul>
                <ul class="select-list" v-else-if="lotteryTypeCode === 'LHC'">
                  <li @click="selectPlay(item)" :class="{ 'active': currPlay === item.code }"
                    v-for="(item, index) in LhcSelect" :key="index">
                    <a>{{ item.text }}</a>
                  </li>
                </ul>
                <ul class="select-list" v-else-if="lotteryTypeCode === 'PK10'">
                  <li @click="selectPlay(item)" :class="{ 'active': currPlay === item.code }"
                    v-for="(item, index) in Pk10Select" :key="index">
                    <a>{{ item.text }}</a>
                  </li>
                </ul>
                <ul class="select-list" v-else>
                  <li class="active"> 基本走势 </li>
                </ul>
              </div>
            </div>
          </div>
          <div  v-if="chartLoading">
            <div class="wrap-loading">
              <div class="notContent">
                <img src="../assets/icon_loading.svg">
                <div class="ball-shadow"></div>
                <p>资料加载中</p>
              </div>
            </div>
          </div>
          <div class="listcontent" v-else>
            <div class="box">
              <div class="bastren" id="bastren">
                <div class="chartLinediv">
                  <trendK3 v-if="lotteryTypeCode === 'K3'"></trendK3>
                  <trendpl3 v-if="lotteryTypeCode === 'PL3' || lotteryTypeCode === '3D' || lotteryTypeCode === 'PCDD'">
                  </trendpl3>
                  <trend11x5 v-if="lotteryTypeCode === '11X5'"></trend11x5>
                  <trendssq v-if="lotteryTypeCode === 'SSQ'"></trendssq>
                  <trendDlt v-if="lotteryTypeCode === 'DLT'"></trendDlt>
                  <trendzhishu v-if="lotteryTypeCode === 'ZHISHU'"></trendzhishu>
                  <trendssc v-if="lotteryTypeCode === 'SSC'" :currPlay="currPlay"></trendssc>
                  <trendlhc v-if="lotteryTypeCode === 'LHC'" :currPlay="currPlay"></trendlhc>
                  <trendpk10 v-if="lotteryTypeCode === 'PK10'" :currPlay="currPlay"></trendpk10>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mix from "~/mixins/home.mixins.vue";
import openLottery from '~/components/openLottery.vue';
import trendK3 from "./bet/trend/trendK3";
import trendpl3 from "./bet/trend/trendPL3";
import trend11x5 from "./bet/trend/trend11x5";
import trendssq from "./bet/trend/trendssq";
import trendDlt from "./bet/trend/trendDlt";
import trendzhishu from "./bet/trend/trendzhishu";
import trendssc from "./bet/trend/trendssc";
import trendlhc from "./bet/trend/trendlhc";
import trendpk10 from "./bet/trend/trendpk10";
export default {
  mixins: [mix],
  components: {
    trendK3,
    openLottery,
    trendpl3,
    trend11x5,
    trendssq,
    trendDlt,
    trendzhishu,
    trendssc,
    trendlhc,
    trendpk10
  },
  data() {
    return {
      isShow: null,
      lotteryTypeCode: '',
      lotteryCode: '',
      qsList: [
        { name: '近30期', val: 30 },
        { name: '近50期', val: 50 },
        { name: '近200期', val: 200 },
      ],
      currPlay: '',
      SscSelect: [
        { code: 'wx', text: '五星' },
        { code: 'wxzh', text: '五星综合' },
        { code: 'sx', text: '四星' },
        { code: 'qs', text: '前三' },
        { code: 'zs', text: '中三' },
        { code: 'hs', text: '后三' },
        { code: 'qe', text: '前二' },
        { code: 'he', text: '后二' }
      ],
      LhcSelect: [
        { code: 6, text: '特码' },
        { code: 0, text: '正码一' },
        { code: 1, text: '正码二' },
        { code: 2, text: '正码三' },
        { code: 3, text: '正码四' },
        { code: 4, text: '正码五' },
        { code: 5, text: '正码六' }
      ],
      Pk10Select: [
        { code: 'gj', text: '冠军' },
        { code: 'yj', text: '亚军' },
        { code: 'jj', text: '季军' },
        { code: 'dsm', text: '第四名' },
        { code: 'dwm', text: '第五名' },
        { code: 'dlm', text: '第六名' },
        { code: 'dqm', text: '第七名' },
        { code: 'dbm', text: '第八名' },
        { code: 'djm', text: '第九名' },
        { code: 'dtm', text: '第十名' }
      ],
    };
  },
  watch: {
    $route: {
      handler: async function (val, oldVal) {
        if (val.name == 'lotterychart') {
          if (Object.keys(val.query).length == 0) {
            this.$store.dispatch("lottery/getLotterylist").then(() => {
              this.defaultlottery();
            })
          } else {
            this.lotteryTypeCode = this.$route.query.lotteryTypeCode
            this.lotteryCode = this.$route.query.lotteryCode
            this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
            this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
            // 走势图部分
            this.$store.commit("trend/setchartLoading", true);
            await this.$store.dispatch("trend/getHisPeriodsPage", this.lotteryCode);
            this.$store.commit("trend/setlotteryNumbTypeCode", this.lotteryTypeCode);
            this.$store.commit("trend/setchartLoading", false);
            if (this.lotteryTypeCode === 'SSC') {
              this.currPlay = 'wx'
            } else if (this.lotteryTypeCode === 'LHC') {
              this.currPlay = 6
            } else if (this.lotteryTypeCode === 'PK10') {
              this.currPlay = 'gj'
            } else {
              this.currPlay = ''
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    chartLoading() {
      return this.$store.state.trend.chartLoading;
    },
    // 开奖数组
    lotteryTrendList() {
      return this.$store.getters["trend/lotteryTrendList"]
    },
    // 期数
    periodsLimit: {
      get() {
        return this.$store.state.trend.periodsLimit;
      },
      set(e) {
        this.$store.commit("trend/setperiodsLimit", e);
      }
    },
    // 辅助线
    statisticalShow: {
      get() {
        return this.$store.state.trend.statisticalShow;
      },
      set(e) {
        this.$store.commit("trend/setStatisticalShow", e);
      }

    },
    // 遗漏
    onMissHandleChange: {
      get() {
        return this.$store.state.trend.missNumberShow;
      },
      set(e) {
        this.$store.commit("trend/setMissNumberShow", e);
      }

    },
    // 折线
    lineChartShow: {
      get() {
        return this.$store.state.trend.lineChartShow;
      },
      set(e) {
        this.$store.commit("trend/setLineChartShow", e);
      }

    },
    // 所有彩票游戏
    hotLotteryList() {
      return this.$store.state.lottery.LotteryLatelyLpVo
    },
    // 大发彩票类型列表
    dflotteryTypes() {
      let list = []
      this.$store.state.lottery.lotteryTypes.forEach((item) => {
        if (item.lotteryTypeName) {
          list.push({
            lotteryTypeName: item.lotteryTypeName,
            lotteryTypeCode: item.lotteryTypeCode
          })
        }
      })
      return list
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      this.init()
    }
  },
  beforeDestroy() {
    this.$store.commit("lottery/setLotteryLatelyLpVo", []);
    this.$store.commit("lottery/clearLotteryLatelyTimer");
    this.$store.commit("lottery/setPage", 1);
  },
  methods: {
    selectPlay(item) {
      this.currPlay = item.code
    },
    async init() {
      this.lotteryTypeCode = this.$route.query.lotteryTypeCode;
      this.lotteryCode = this.$route.query.lotteryCode;
      this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
      this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
      this.$store.commit("trend/setlotteryTypeCode", this.lotteryTypeCode);
      this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
      this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
      this.$store.dispatch("lottery/getLotterylist"); // 所有彩种

      // 走势图部分
      if (this.lotteryTypeCode === 'SSC') {
        this.currPlay = 'wx'
      } else if (this.lotteryTypeCode === 'LHC') {
        this.currPlay = 6
      } else if (this.lotteryTypeCode === 'PK10') {
        this.currPlay = 'gj'
      } else {
        this.currPlay = ''
      }
      this.$store.commit("trend/setchartLoading", true);
      await this.$store.dispatch("trend/getHisPeriodsPage", this.lotteryCode);
      this.$store.commit("trend/setlotteryNumbTypeCode", this.lotteryTypeCode);
      this.$store.commit("trend/setchartLoading", false);
    },
    toLottery(item) {
      this.$router.push({
        name: "lotterychart",
        query: {
          lotteryTypeCode: item.lotteryTypeCode,
          lotteryCode: item.lotteryCode,
        },
      });
    },
    // 首次进入时默认第一个彩票类型得第一个彩票游戏
    defaultlottery() {
      this.lotteryTypeCode = this.dflotteryTypes[0]['lotteryTypeCode'];
      this.lotteryCode = this.ltList(this.lotteryTypeCode)[0]['lotteryCode']
      this.lotteryTypeCode = this.$route.query.lotteryTypeCode || this.lotteryTypeCode;
      this.lotteryCode = this.$route.query.lotteryCode || this.lotteryCode;
      this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
      this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
      this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
      this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
      this.$store.dispatch("lottery/getLotterylist"); // 所有彩种
      this.$router.push({
        name: "lotterychart",
        query: {
          lotteryTypeCode: this.lotteryTypeCode,
          lotteryCode: this.lotteryCode,
        },
      });
    },
    setIshowIdx(idx) {
      this.isShow = idx;
    },
    ltList(type) {
      let arr = this.hotLotteryList.filter((item, i) => {
        return item.lotteryTypeCode == type
      })
      return arr
    }
  }
};
</script>
<style lang="less">
.component-trandchart {
  .dxdsactive {
    background-color: #525368;
    color: #fff;
  }

  .trend-table-box {
    position: relative;
    display: inline-block;

    .trend-canvas {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  tr.trend-content-tr {
    border-bottom: 1px solid #d2d2d2;

    &:nth-of-type(even) {
      background-color: #e6e6e6;
    }

    .basic-td {
      &:last-child {
        border-right: 0;
      }
    }
  }

  .td-right-border {
    border-right: 1px solid #d2d2d2;
  }

  .td-bleft-border {
    border-left: 1px solid #3a3b50 !important;
  }

  .td-bright-border {
    border-right: 1px solid #3a3b50 !important;
  }

  .trend-table-container {
    position: relative;
    overflow: auto;
    padding: 0 0px 20px;
    margin: 0 20px 20px;
    text-align: center;
  }

  .trend-table {
    // min-width: 100%;
    table-layout: fixed;
    background-color: #fff;

    .trend-head {
      background-color: #525368;

      td {
        line-height: 30px;
        height: 30px;
        text-align: center;
        color: #fff;
        font-size: 12px;
      }

      &.drawnumb {
        background-color: #3a3b50;

        .basic-td {
          border-right: 1px solid transparent;
          line-height: initial;
          height: initial;
          box-sizing: border-box;
        }
      }
    }

    .draw-number {
      color: #B5669E;
    }

    .basic-td {
      font-size: 0;
      padding: 3px;
      text-align: center;
      box-sizing: border-box;

      span {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;

        &.active {
          border-radius: 24px;
          background-color: #FF9900;
          color: #fff;
          position: relative;
          z-index: 10;
        }
      }
    }

    .periods-td {
      height: 30px;
      line-height: 30px;
      text-align: center;
      padding: 0 10px;
      border-right: 1px solid #d2d2d2;
    }

    .periods-head {
      min-width: 120px;
      border-right: 1px solid #d2d2d2;

      span {
        font-size: 12px;
      }
    }

    .drawnumb-head {
      min-width: 80px;
      border-right: 1px solid #d2d2d2;

      span {
        font-size: 12px;
      }
    }
  }
}

.wrap-loading {
  margin-top: 150px;

  .notContent {
    text-align: center;
  }
}

.chart-menu-components-df {
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  width: 100%;
  height: 50px;
  font-size: 16px;

  .mian {
    background: #fff;


    .grid_header>.grid_column .innerTitle+.innerTitle {
      margin-left: 10px
    }

    .record-lottery-component {
      width: 1200px;
      margin: 20px auto;
    }


    .wrap {
      width: 1200px;
      height: 50px;
      margin: 0 auto;

      .select-trand {
        max-width: 1200px;
        background: #fff;
        border: 1px solid #d3d3d3;
        box-shadow: 0 0 8px rgba(0, 0, 0, .08);
        margin: 20px auto;

        .select-header {
          position: relative;
          background: #f5f5f5;
          padding: 16px 40px;
          border-bottom: 1px solid #d3d3d3;

          .select-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
          }

          .select-line {
            display: block;
            width: 100%;
            position: absolute;
            height: 1px;
            top: 60px;
            left: 0;
            border-bottom: 1px dashed #d3d3d3;
          }

          .select-bottom {
            padding-top: 14px;
            font-size: 14px;

            .choose-play {
              display: flex;
            }

            .select-title {
              padding: 4px 0;
            }

            .select-list {
              list-style: none;
              padding: 0;

              li {
                display: inline-block;
                padding: 4px 12px;
                border-radius: 2px;
                color: #333;
                margin: 0 5px;
                cursor: pointer;

                &:hover {
                  background: #19aecf;
                  color: #fff;
                }
              }

              .active {
                background: #19aecf;
                color: #fff;
              }
            }
          }

          .time {
            display: flex;

            span {
              background: #fff;
              border: 1px solid #d3d3d3;
              border-radius: 2px;
              padding: 4px 12px;
              margin-left: 10px;
              cursor: pointer;
              font-size: 14px;

              &:hover {
                background: #19aecf;
                color: #fff;
                border-color: #19aecf
              }
            }

            .active {
              background: #19aecf;
              color: #fff;
              border-color: #19aecf
            }
          }

          .check-click {
            display: flex;
          }

          .checkbox-wrapper {
            margin-right: 20px;
          }
        }

        .listcontent {
          width: 100%;
          height: auto;
          overflow: hidden;
          padding: 30px 40px;

          .box {
            width: 100%;
            height: auto;
            overflow: hidden;
          }

          .bastren {
            clear: both;
            overflow-x: auto;
            overflow-y: hidden;
            position: relative;
            border: 1px solid #ccc;
            border-top: none;
            border-bottom: none;
          }

          .chartLinediv {
            position: relative;

            .trend-canvas {
              position: absolute;
              left: 0;
              top: 0;
            }

            .ball-noraml {
              color: #b7b7b7;
              display: inline-block;
              user-select: none;
              width: 15px;
              height: 15px;
              line-height: 14px;
              text-align: center;
              font-style: normal;
              position: relative;
              box-sizing: border-box;
            }

            .hezhixingtai {
              width: auto;
              height: 25px;
              line-height: 25px;
            }

            .chart-table {
              font: 12px/1.4 Microsoft YaHei, PingFang SC, Helvetica, Helvetica Neue, Tahoma, Arial, sans-serif;
              width: 100%;
              box-sizing: border-box;
              line-height: 24px;
              border-right: 1px solid #ccc;

              .isHmxt {
                padding: 0 !important;
                background: #f53f00 !important;

                .haomaxingtai {
                  display: block;
                  background: #f53f00;
                  color: #fff;
                }
              }

              .isSHow {
                padding: 0 !important;
                background: #00a2ff !important;

                .haomaxingtai {
                  display: block;
                  background: #00a2ff;
                  color: #fff;
                }

                .hezhixingtai {
                  display: block;
                  background: #00a2ff;
                  color: #fff;
                }
              }

              .KuaiSan_OpenNo {
                .chonghao {
                  position: absolute;
                  z-index: 10;
                  width: 14px;
                  height: 14px;
                  background-color: #00a2ff;
                  color: #fff;
                  font: 12px/1.5;
                  border-radius: 50%;
                  margin-top: -5px;
                  margin-right: -2px;
                  box-sizing: border-box;
                }
              }

              .openNo {
                background: url('../assets/trend/un-chart.png') no-repeat 0 0;
                color: #fff !important;
              }

              .openNo-0 {
                background: url('../assets/trend/un-chart.png') no-repeat 0 0;
                color: #fff !important;
              }

              .openNo-1 {
                background: url('../assets/trend/un-chart.png') no-repeat -60px 0;
                color: #fff !important;
              }

              .openNo-2,
              .openNo-3,
              .openNo-4,
              .openNo-5 {
                background: url('../assets/trend/un-chart.png') no-repeat -80px 0;
                color: #fff !important;
              }

              th {
                padding: 5px 0;
                background-color: #f2f2f2;
                text-align: center;
                font-style: normal;
                box-sizing: border-box;

                .ball-noraml {
                  color: #333;
                }
              }

              td {
                padding: 5px 0;
                border-bottom: 1px solid #fff;
                border-top: 1px solid #fff;
                background-color: #fff;
                text-align: center;
              }

              .haomaxingtai {
                width: auto;
                height: 25px;
                line-height: 25px;
              }

              .hezhixingtai {
                width: auto;
                height: 25px;
                line-height: 25px;
              }

              .KuaiSan {
                width: auto;
                padding: 0;
              }

              .issue-numbers {
                width: auto;
              }

              .lottery-numbers {
                width: auto;
              }

              .border-bottom-header {
                border-bottom: 1px solid #ccc;
              }

              .border-right {
                border-right: 1px solid #ccc;
              }

              .border-left {
                border-left: 1px solid #ccc;
              }

              .border-top {
                border-top: 1px solid #e6e6e6;
              }

              .border-bottom {
                border-bottom: 1px solid #ccc;
              }

              .ball-none {
                width: 4px;
              }

              .openNo-kuadu-td {
                padding: 0;
              }

              .navTxt {
                margin-left: 5px;
              }

              .pdd {
                padding: 2px;
                color: #fff !important;
                border-radius: 10px;
                background-color: #f53f00;
              }

              .green {
                background: linear-gradient(180deg, #41e07c 30%, #38b467);
                border: 1px solid #3cb569;
              }

              .red {
                background: linear-gradient(180deg, #ff6669 30%, #e53a3d);
                border: 1px solid #e94548;
              }

              .blue {
                background: linear-gradient(180deg, #33a8ff 30%, #228ede);
                border: 1px solid #2994e3;
              }

              .block-blue {
                background: linear-gradient(180deg, #33a8ff 30%, #228ede);
                color: #fff;
              }

              .block-green {
                background: linear-gradient(180deg, #41e07c 30%, #38b467);
                color: #fff;
              }

              .block-red {
                background: linear-gradient(180deg, #ff6669 30%, #e53a3d);
                color: #fff;
              }

              .bgcolor {
                background: rgba(255, 235, 59, .25);
              }

              .dxxintai {
                padding: 0;

                i {
                  display: block;
                  width: 100%;
                  height: 27px;
                  line-height: 27px;
                  overflow: hidden;
                  padding: 0;
                }
              }

              .bgc_blue {
                padding: 0;
                background: #00a2ff;
                color: #fff;

                i {
                  color: #fff;
                }
              }

              .bgc_green {
                padding: 0;
                background: #34bc0f;
                color: #fff;

                i {
                  color: #fff;
                }
              }

              .bgc_red {
                padding: 0;
                background: #f53f00;
                color: #fff;

                i {
                  color: #fff;
                }
              }

              .openNo-kuadu {
                padding: 0;
                background: #00a2ff;
                color: #fff;
                display: block;
                height: 26px;
                line-height: 26px;
                text-align: center;
                width: 100%;
              }

              .zusan {
                padding: 0 2px;

                i {
                  display: block;
                  margin: 0 auto;
                }
              }

              .duizi {
                background: url('../assets/trend/un-chart.png') no-repeat -100px;
                color: #fff;
                height: 27px;
                width: 18px;
                line-height: 27px;
              }

              ._bili {
                padding: 0;

                i {
                  background-color: #7999f3;
                  color: #fff;
                  display: block;
                  width: 100%;
                  height: 27px;
                  line-height: 27px;
                  padding: 0;
                  overflow: hidden;
                }
              }

              .padd3 {
                position: relative;
                z-index: 999;
                background: linear-gradient(180deg, #ff6669 30%, #e53a3d);
                border: 1px solid #e94548;
                padding: 2px;
                color: #fff;
                border-radius: 10px;
                background-color: #f53f00;
                width: auto;
                height: auto;
              }

              .paddssqb {
                position: relative;
                z-index: 999;
                background: linear-gradient(180deg, #668fff 30%, #3a45e5);
                border: 1px solid #455ee9;
                padding: 2px;
                color: #fff;
                border-radius: 10px;
                background-color: #0056f5;
                width: auto;
                height: auto;
              }

              .padddlty {
                position: relative;
                z-index: 999;
                background: linear-gradient(180deg, #ffe366 30%, #e5b43a);
                border: 1px solid #e9de45;
                padding: 2px;
                color: #fff;
                border-radius: 10px;
                background-color: #f5f100;
                width: auto;
                height: auto;
              }

              .title-text {
                box-sizing: border-box;
                letter-spacing: -.4px;

                th {
                  min-width: 80px;
                  font-weight: 500;
                  white-space: nowrap;
                  word-wrap: break-word;
                  border: 1px solid #ccc;
                }
              }

              .title-text th:first-child {
                border-left: none;
              }

              .title-number {
                th {
                  padding-top: 0;
                }
              }

              .tbody {
                color: #888;
              }
            }
          }
        }
      }

      .menulist {
        display: flex;
        align-items: center;
        height: 50px;
        font-size: 16px;
      }

      .menu_item {
        width: 80px;
      }

      .menu_title {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        cursor: pointer;
        font-size: 16px;
        color: #000
      }

      ul.inner_menu {
        transition: .5s;
        position: absolute;
        z-index: 10;
        background: #fff;
        box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
        height: auto;
        grid-template-columns: 1fr 1fr;
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content;
        cursor: pointer;
        top: 50px;
        left: 0;
      }

      .menu_item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        color: #666;
        margin-right: 21px;
        cursor: pointer;
        position: relative;
        padding: 0 5px
      }

      .arrow {
        transition: .3s;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4px 0 4px;
        border-color: #999 transparent transparent transparent;
        transform: rotate(0deg);
        margin-left: 6px
      }
    }
  }
}


.wrap .menu_item:hover .arrow {
  border-color: #ec5141 transparent transparent transparent;
  transform: rotate(180deg)
}

.home-menu-component .wrap .menuItem {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  color: #666;
  margin-right: 21px;
  cursor: pointer;
  position: relative;
  padding: 0 5px;
}

.wrap .wrapper_menu+.wrapper_menu {
  margin-left: 43px
}

.wrap ul.inner_menu>li {
  padding: 5px;
  margin: 5px 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center
}

.wrap ul.inner_menu>li:hover {
  color: #fff;
  background: #ec5141
}

.wrap ul.wrapper_menu>li:hover:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #ec5141
}

.wrap ul.column-one {
  grid-template-columns: 1fr !important
}

.wrap ul.column-two {
  grid-template-columns: 1fr 1fr !important
}

.wrap ul.column-three {
  grid-template-columns: 1fr 1fr 1fr !important
}

.wrap ul.column-four {
  grid-template-columns: repeat(4, 1fr)
}

.wrap ul.wrapper_menu>li {
  position: relative
}

.wrap ul.wrapper_menu>li:hover {
  color: #ec5141
}

.wrap ul.wrapper_menu>li:hover:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #ec5141
}

.wrap ul.wrapper_menu:hover.inner_menu {
  display: grid
}

.wrap ul.inner_menu {
  transition: .5s;
  display: none;
  position: absolute;
  z-index: 10;
  background: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  grid-template-columns: 1fr 1fr;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  cursor: pointer
}
</style>